@if (resAsync | async) {
  <div style="padding: 0px 15px; background-color: #fff !important; overflow-y: auto">
    @if (!loading && (ordersObservable$ | async); as orders) {
      @if (orders.length) {
        <div class="container">
          <p style="font-size: 30px; font-weight: bold; margin: 0px">
            {{ res.get('Order-Selection-TitleOrders') }}
          </p>
          <abc-text-box
            class="orderSelectionFilter"
            [height]="'40px'"
            [mode]="'search'"
            [showClearButton]="true"
            [stylingMode]="'outlined'"
            [(value)]="filterText"
            valueChangeEvent="keyup"
            [width]="'300px'"
          >
          </abc-text-box>
        </div>
        <mat-list>
          <mat-divider></mat-divider>
          @for (order of orders | OrderselectionFilter: filterText; track trackById($index, order)) {
            <mat-list-item>
              <mat-divider class="matDividerListItem"></mat-divider>
              <div class="orderButtonContainer">
                <div class="orderContainer">
                  <div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%">
                      <div fxLayout="column" class="itemLine">
                        <div fxLayout="row">
                          <p class="orderDesignation" matListItemTitle>
                            {{ order.designation }}
                          </p>
                          @if (order.isDownloaded) {
                            <mat-icon
                              [svgIcon]="res.svgName('Order-Selection-StateOffline-Image')"
                              class="orderWorksCommonIcon"
                            ></mat-icon>
                          }
                        </div>
                        <p class="orderRemark">{{ order.remark }}</p>
                      </div>
                    </div>
                  </div>
                  <table matListItemTitle class="itemLine orderTable">
                    <tr>
                      <td class="orderWorksAll">
                        {{ res.get('Order-Selection-TotalWorks', order.countWorks) }}
                      </td>
                      <td>
                        <div fxLayout="row" fxLayout.xs="column">
                          <div class="orderWorksCommon orderWorksDone">
                            <mat-icon
                              [svgIcon]="res.svgName('Order-Selection-StateDone-Image')"
                              class="orderWorksCommonIcon"
                            ></mat-icon>
                            {{ res.get('Order-Selection-TotalWorksDone', order.countWorksDone) }}
                          </div>
                          <div class="orderWorksCommon orderWorksPartial">
                            <mat-icon
                              [svgIcon]="res.svgName('Order-Selection-StatePartial-Image')"
                              class="orderWorksCommonIcon"
                            ></mat-icon>
                            {{ res.get('Order-Selection-TotalWorksPartial', order.countWorksPartial) }}
                          </div>
                          <div class="orderWorksCommon orderWorksPartial">
                            <mat-icon
                              [svgIcon]="res.svgName('Order-Selection-StateOpen-Image')"
                              class="orderWorksCommonIcon"
                            ></mat-icon>
                            {{ res.get('Order-Selection-TotalWorksOpen', order.countWorksOpen) }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                  <p class="itemLine workCreationDate" matListItemTitle>
                    {{
                      res.get(
                        'Order-Selection-WorkCreationDate',
                        this.ConvertHelper.toLocaleFormattedDateString(order.date.toString(), true)
                      )
                    }}
                  </p>
                  <mat-progress-bar
                    matListItemTitle
                    mode="determinate"
                    [value]="order.donePercentage"
                    [ngClass]="'progressBarNormal'"
                    [ngClass.xs]="'progressBarSmall'"
                  ></mat-progress-bar>
                </div>
                <button
                  class="orderConfirmButton"
                  mat-mdc-raised-button
                  (click)="selectOrder(order)"
                  [disabled]="!order.canSelect"
                >
                  <mat-icon
                    [svgIcon]="res.svgName('Order-Selection-ArrowForward-Image')"
                    class="orderConfirmButtonIcon"
                  ></mat-icon>
                </button>
              </div>
            </mat-list-item>
          }
        </mat-list>
        <br />
        <br />
      } @else {
        <p>{{ res.get('Order-Selection-NoOrderMessage') }}</p>
        <br />
      }
    } @else {
      <p>{{ res.get('Order-Selection-LoadingOrdersWaitingMessage') }}</p>
      <div class="noDataPlaceHolder">
        {{ res.get('Order-Selection-LoadingOrdersSuccessMessage') }}
      </div>
    }
    <div>
      <button
        id="refreshButton"
        class="bottomButtonNav"
        mat-icon-button
        [matTooltip]="res.get('Order-Selection-ReloadOrders')"
        (click)="refresh()"
      >
        <mat-icon [svgIcon]="res.svgName('Order-Selection-Refresh-Image')" class="bottomButtonIcon"></mat-icon>
      </button>
      <button
        id="selectProfileButton"
        class="bottomButtonNav"
        mat-icon-button
        [matTooltip]="res.get('UserProfile-Selection')"
        (click)="selectProfile()"
      >
        <mat-icon [svgIcon]="res.svgName('Order-Selection-SelectProfile-Image')" class="bottomButtonIcon"></mat-icon>
      </button>
      @if (canLogout) {
        <button
          id="logoutButton"
          class="bottomButtonNav"
          mat-icon-button
          [matTooltip]="res.get('Logout')"
          (click)="logout()"
        >
          <mat-icon [svgIcon]="res.svgName('Order-Selection-Logout-Image')" class="bottomButtonIcon"></mat-icon>
        </button>
      }
    </div>
    <br />
  </div>
}
